/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Code for photo management

namespace('Slzr.Page', function(exports, top) {
  const $ = Slzr.jQuery;

  exports.PhotoManagement = class PhotoManagement {
    constructor() {
      // Initialize MultiUploadSelector
      this.selectPhoto = this.selectPhoto.bind(this);
      const input = $('[data-multi-upload="input"]');
      const container = $('[data-multi-upload="input-container"]');
      const file_list = $('[data-multi-upload="list"]');

      new Slzr.MultiUploadSelector({
        file_list,
        input,
        input_container: container,
        template: "<div class=\"item ugc_item\"><h3><span><%= filename %></span><span class=\"deletex\"><a href=\"#\" class=\"remove-link\">&times;</a></span></h3><div class=\"form_box\"><label><input type=\"text\" name=\"caption[]\" placeholder=\"Add caption\" /></label></div></div>"
      });

      // Attach photo selection
      $(document).onAction('select-photo', this.selectPhoto);

      // photoSaved function
      // this needs to be global because it's called back from server :/
      top.photoSaved = () => $('li a.selectedphoto').removeClass('selectedphoto');

      $(document).on('change', '[data-action="select-album"]', function() {
        return updateUrl({album_id: $(this).val()});
      });
    }

    selectPhoto(ev) {
      const $target = $(ev.target).closest('a[data-action="select-photo"]');

      // Unmark all selected photos
      $('.icon_item td.selectedphoto').removeClass('selectedphoto');
      // and the current item as selected
      $target.closest('td').addClass('selectedphoto');

      // update the sidebar
      const photo_id = $target.data('photoId');
      let url = "/photo/@PHOTO_ID@/edit";
      url = url.replace('@PHOTO_ID@', photo_id); // WP_CHANGE: probably can get rid of this line with interpolation above

      return $.get(url, {}, data => $('#x-photo-edit').html(data));
    }
  };

  return $(function() {
    if (Slzr.Meta.page === 'manage-photos') { return new Slzr.Page.PhotoManagement; }
  });
});